// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label_Label__t50hJ"};